const getOptionKey = (opt) => opt?.pk ?? opt?.id;

const getOptionLabel = (option) =>
  option?.name ?? option?.client_name ?? option?.client?.name ?? "";

const normalizeSelectableCase = (option) => {
  if (!option) {
    return option;
  }
  if (typeof option.show_delete === "boolean") {
    return option;
  }
  return { ...option, show_delete: true };
};

const dedupeByCaseKey = (list = []) => {
  const seen = new Set();
  return list.filter((item) => {
    const key = getOptionKey(item);
    if (!key || seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
};

const normalizeCaseCollection = (list = []) =>
  dedupeByCaseKey(
    (Array.isArray(list) ? list : []).map((item) => normalizeSelectableCase(item)).filter(Boolean)
  );

const splitCaseCollection = (list = []) => {
  const normalized = normalizeCaseCollection(list);
  return {
    locked: normalized.filter((item) => item?.show_delete === false),
    editable: normalized.filter((item) => item?.show_delete !== false),
  };
};

const areCaseListsEqual = (listA = [], listB = []) => {
  const normalizedA = normalizeCaseCollection(listA);
  const normalizedB = normalizeCaseCollection(listB);

  if (normalizedA.length !== normalizedB.length) {
    return false;
  }

  for (let i = 0; i < normalizedA.length; i += 1) {
    if (getOptionKey(normalizedA[i]) !== getOptionKey(normalizedB[i])) {
      return false;
    }
  }

  return true;
};

export {
  areCaseListsEqual,
  dedupeByCaseKey,
  getOptionKey,
  getOptionLabel,
  normalizeCaseCollection,
  splitCaseCollection,
};
